module.exports = now

function now() {
    return new Date().getTime()
}



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/~/console-browserify/~/date-now/index.js
// module id = 95
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 17 18 20 21 22 23 24 25 26 27 28 29